const Roles = {
  ADMINISTRATOR: 'administrator',
  CASHIER: 'cashier',
  UNKNOWN: 'unknown',
};

export const roleOptions = [
  { label: Roles.ADMINISTRATOR, value: Roles.ADMINISTRATOR },
  { label: Roles.CASHIER, value: Roles.CASHIER },
]

export const roleOptionStrings = [
  Roles.ADMINISTRATOR,
  Roles.CASHIER,
]

export const normalizeRole = (role) => {
  switch ((role || '').toString().trim().toLowerCase()) {
    case 'analytic':
    case 'administrator':
      return Roles.ADMINISTRATOR;
    case 'employer':
    case 'qr':
    case 'cashier':
      return Roles.CASHIER;
    default:
      return role;
  }
};

 export default Roles